// eslint-disable-next-line import/prefer-default-export
export default function decodeBase64(value, defaultValue = '') {
  try {
    return atob(value) || defaultValue;
  } catch (e) {
    return defaultValue;
  }
}
